<!--
@Author: Calvin Green <calvin>
@Date:   2022-03-18T14:07:39+02:00
@Email:  calvin@diversitude.com
@Last modified by:   calvin
@Last modified time: 2022-06-22T19:02:44+02:00
@Copyright: Diversitude 2022
-->

<template>
    <b-modal size="xl" hide-footer title="Manage User" id="manageUsersModal">
        <div class="modal-body">
            <b-tabs nav-class="nav-tabs-custom" v-model="tabIndex"  content-class="p-3 text-muted">
                <b-tab active>
                    <template v-slot:title>
                        <span class="d-none d-sm-inline-block">Form</span>
                    </template>
                    <b-form autocomplete="off" class="usersForm" v-if="show_form">
                        <b-row>
                            <b-col cols="6">
                                <b-form-group id="name" label="Name" label-for="name-input">
                                    <b-form-input size="sm" id="name-input" v-model="form.name" type="text" placeholder="Enter name" required></b-form-input>
                                </b-form-group>
                            </b-col>

                            <b-col cols="6">
                                <b-form-group id="email" label="Email" label-for="email-input">
                                    <b-form-input size="sm" id="email-input" v-model="form.email" type="email" placeholder="Enter email" required></b-form-input>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row v-show="user_id > -1">
                            <b-col cols="6" >
                                <b-form-group :id="generateRandomId()" label="Password" label-for="email-input">
                                    <b-form-input autocomplete="new-password" size="sm" :id="generateRandomId()" v-model="form.password" type="password" placeholder="Enter New Password" ></b-form-input>
                                </b-form-group>
                            </b-col>

                            <b-col cols="6" >
                                <b-form-group :id="generateRandomId()" label="Confirm Password" label-for="email-input">
                                    <b-form-input autocomplete="new-password" size="sm" :id="generateRandomId()" v-model="form.password2" type="password" placeholder="Confirm Password" ></b-form-input>
                                </b-form-group>
                            </b-col>
                        </b-row>
                <!-- --------------------- -->
                        <b-row>
                            <b-col cols="4">
                                <b-form-group id="cell_no" label="Cell No" label-for="number-input">
                                    <b-form-input size="sm" id="number-input" v-model="form.cell_no" type="number" placeholder="Enter cell number" required></b-form-input>
                                </b-form-group>
                            </b-col>

                            <b-col cols="4">
                                <b-form-group id="id_number" label="ID Number" label-for="id-input">
                                    <b-form-input autocomplete="never" size="sm" id="id-input" v-model="form.id_number" type="text" placeholder="ID number" required></b-form-input>
                                </b-form-group>
                            </b-col>

                            <b-col cols="4">
                                <b-form-group id="years_experience" label="Years Experience" label-for="years_experience-input">
                                    <b-form-input size="sm" id="years_experience-input" v-model="form.years_experience" type="number" placeholder="Enter years of experience" required></b-form-input>
                                </b-form-group>
                            </b-col>
                        </b-row>
                <!-- --------------------- -->
                        <b-row>
                            <b-col cols="12">
                                <b-form-group id="academic_qualifications" label="Academic Qualifications" label-for="academic_qualifications-input">
                                    <b-form-textarea size="sm" id="academic_qualifications-input" v-model="form.academic_qualifications" type="phone" placeholder="Enter academic qualifications" required></b-form-textarea>
                                </b-form-group>
                            </b-col>
                        </b-row>

                        <b-row>
                            <b-col cols="12">
                                <b-form-group id="designation" label="Designation" label-for="designation-input">
                                    <b-form-textarea size="sm" id="designation-input" v-model="form.designation" type="text" placeholder="Designation description" required></b-form-textarea>
                                </b-form-group>
                            </b-col>
                        </b-row>

                        <b-row>
                            <b-col cols="12">
                                <b-form-group id="work_qualifications" label="Work Qualifications" label-for="work_qualifications-input">
                                    <b-form-textarea size="sm" id="work_qualifications-input" v-model="form.work_qualifications" type="text" placeholder="Enter work qualifications" required></b-form-textarea>
                                </b-form-group>
                            </b-col>
                        </b-row>
                    </b-form>
                </b-tab>
                <b-tab lazy>
                    <template v-slot:title>
                        <span class="d-none d-sm-inline-block">Documents</span>
                    </template>
                    <div v-show="hasAtleastOneUpload" class="card-title">Upload/Download Files
                        <b-button class="ms-auto" @click="downloadAllFiles" style="margin-top: -4px; float:right" variant="primary" size="sm">Download All Attachments</b-button>
                    </div>
                    <hr>

                    <!-- //* show elements if user exists -->
                    <b-row class="form-row" v-if="user_id > -1">
                        <b-col cols="4">
                            <label class="d-flex">ID Copy
                                <span class="ms-auto">
                                    <b-button v-if="form.id_copy_s3_src != null" @click="downloadFile('id_copy')" size="sm" variant="primary" >
                                        Download
                                    </b-button>
                                    <b-button size="sm" v-else>No File Available</b-button>
                                </span>
                            </label>
                            <FileUpload @fileSuccess="handleFileSuccess()" :user_id="user_id" type="id_copy"/>

                        </b-col>

                        <b-col cols="4">
                            <label class="d-flex">Letter of Appointment
                                <span class="ms-auto">
                                    <b-button  v-if="form.letter_of_appointment_s3_src != null" @click="downloadFile('letter_of_appointment')" size="sm" variant="primary" >
                                        Download
                                    </b-button>
                                    <b-button size="sm" v-else>No File Available</b-button>
                                </span>
                            </label>
                            <FileUpload @fileSuccess="handleFileSuccess()" :user_id="user_id" type="letter_of_appointment"/>
                        </b-col>

                        <b-col cols="4">
                            <label class="d-flex">Letter of Acceptance
                                <span class="ms-auto">
                                    <b-button v-if="form.letter_of_acceptance_s3_src != null" @click="downloadFile('letter_of_acceptance')"  size="sm" variant="primary" >
                                        Download
                                    </b-button>
                                    <b-button size="sm" v-else>No File Available</b-button>
                                </span>
                            </label>
                            <FileUpload @fileSuccess="handleFileSuccess()" :user_id="user_id" type="letter_of_acceptance"/>
                        </b-col>

                        <b-col cols="4" class="pt-4">
                            <label class="d-flex">Job Description
                                <span class="ms-auto">
                                    <b-button v-if="form.job_desc_s3_src != null" @click="downloadFile('job_description')" size="sm" variant="primary" >
                                        Download
                                    </b-button>
                                    <b-button v-else size="sm">No File Available</b-button>
                                </span>
                            </label>
                            <FileUpload @fileSuccess="handleFileSuccess()" :user_id="user_id" type="job_description"/>
                        </b-col>

                        <b-col cols="4" class="pt-4">
                            <label class="d-flex">Police Clearance
                                <span class="ms-auto">
                                    <b-button v-if="form.police_clearance_s3_src != null" @click="downloadFile('police_clearance')" size="sm" variant="primary" >
                                        Download
                                    </b-button>
                                    <b-button v-else size="sm">No File Available</b-button>
                                </span>
                            </label>
                                <FileUpload @fileSuccess="handleFileSuccess()" :user_id="user_id" type="police_clearance"/>
                        </b-col>
                    </b-row>

                    <b-alert variant="danger" show v-else>
                        User does not exist yet.
                    </b-alert>
                </b-tab>
                <b-tab lazy v-if="user_id > -1">
                    <template v-slot:title>
                        <span class="d-none d-sm-inline-block">Assigned Levels</span>
                    </template>
                    <b-dropdown text="Add User To New Level" variant="primary">
                        <b-dropdown-item v-for="(level, idx) in level_dropdown_options" :key="idx" @click="assignLevelToUser(level.value)">
                            {{level.text}}
                        </b-dropdown-item>
                    </b-dropdown>
                    <div>
                        <div class="d-flex">
                            <b-card :title="level.name"
                            v-for="level in user_assigned_levels"
                            :key="level.id" class="border border-primary mt-1 me-1"
                            @mouseenter="hover_level_id = level.id" @mouseleave="hover_level_id = null">
                                <i v-show="hover_level_id == level.id" class="fas fa-trash removeLevelIcon"
                                @click="removeUserFromLevel(level.id)"></i>
                            </b-card>
                        </div>
                    </div>
                </b-tab>
            </b-tabs>
        </div>
        <div class="w-100 d-flex" >
            <span class="ms-auto">
                <b-button v-show="canShowButtofForTabIndex" variant="success" @click="save()">Save</b-button>
                <b-button class="ms-2" v-show="canShowButtofForTabIndex" @click="resetCredentials()" variant="danger">Reset &amp; Sync Credentials</b-button>
                <b-button class="ms-2" @click="$bvModal.hide('manageUsersModal')">Cancel</b-button>
            </span>
        </div>
        <b-overlay :show="is_loading" no-wrap></b-overlay>
    </b-modal>
</template>

<script>
import Swal from 'sweetalert2'
import _ from 'lodash'
import FileUpload from './fileUpload.vue'
import { clientAdminState, clientAdminMethods } from '@/state/helpers'
export default {
    props:{
        user_data:{
            default: {},
        },
        selected_level_id:{
            default: null,
        }
    },
    watch:{
        user_data(newValue){
            if(newValue != null){
                this.form = _.cloneDeep(this.user_data);
                this.is_new_user = false;
            }
        }
    },
    components:{
        FileUpload,
    },
    data:() => ({
        is_loading: false,
        is_new_user: false,
        show_form: false,
        form:{},

        //* id of the level tile assigned to an user
        hover_level_id: null,

        tabIndex: 0,
    }),
    computed:{
        ...clientAdminState,
        canShowButtofForTabIndex(){
            // used to remove save button for lnked levels and doc upload tabs
            return this.tabIndex == 0;
        },
        user_id(){
            if(this.form.id != undefined){
                return this.form.id;
            }
            else{
                return -1;
            }
        },
        user_assigned_levels(){
            let index = _.findIndex(this.all_users, {id: this.user_data.id})
            if(index != -1){
                let levels = _.cloneDeep(this.all_users[index].levels);
                return levels;
            }
            else{
                return [];
            }

        },
        level_dropdown_options(){
            let options = [];
            this.user_levels.forEach( item => {
                options.push({
                    value: item.id,
                    text: item.name,
                })
            })
            return options;
        },
        hasAtleastOneUpload(){
            //returns true if one or more items has scr -> all download button action breaks 
            if(this.form.id_copy_s3_src
                || this.form.job_desc_s3_src
                || this.form.letter_of_acceptance_s3_src
                || this.form.letter_of_appointment_s3_src
                || this.form.police_clearance_s3_src){
                    return true;
                }
                else{
                    return false;
                }
        }
    },
    methods:{
        ...clientAdminMethods,
        handleFileSuccess(){
            //* sync upload src path
            this.is_loading = true;
            let level_id = this.selected_level_id != null ? this.selected_level_id : 0;
            this.loadLevelUsers(level_id).then(()=>{
                this.is_loading = false;
                let id = this.form.id;
                let refreshed_user = _.find(this.all_users, function(o) { return o.id == id; });
                if(refreshed_user){
                    this.form.id_copy_s3_src = refreshed_user.id_copy_s3_src;
                    this.form.job_desc_s3_src = refreshed_user.job_desc_s3_src;
                    this.form.letter_of_acceptance_s3_src = refreshed_user.letter_of_acceptance_s3_src;
                    this.form.letter_of_appointment_s3_src = refreshed_user.letter_of_appointment_s3_src;
                    this.form.police_clearance_s3_src = refreshed_user.police_clearance_s3_src;
                }
            });
        },
        save(){
            this.is_loading = true;
            var params = {
                id: this.form.id,
                level_id: this.selected_level_id,
                name: this.form.name,
                cell_no: this.form.cell_no,
                email: this.form.email,
                designation: this.form.designation,
                id_number: this.form.id_number,
                password: this.form.password,
                academic_qual: this.form.academic_qualifications,
                work_qual: this.form.work_qualifications,
                years_experience: this.form.years_experience,
            };

            if (!this.is_new_user) {
                if (this.form.password != this.form.password2) {
                    Swal.fire({
                        toast: true,
                        position: 'top',
                        iconColor: 'white',
                        icon: 'error',
                        title: "Passwords Don't Match!",
                        customClass: {     popup: 'error-toast' },
                        showConfirmButton: false,
                        timer: 1500,
                        //timer: 2000, timerProgressBar: true
                    });
                    this.is_loading = false;
                    return;
                }
            }

            if(this.is_new_user){
                this.saveUserToLevel(params)
                .then((response)=>{
                    this.loadLevelUsers(this.selected_level_id)
                    .then(()=>{
                        this.is_loading = false;
                        this.$emit('selectNewUser', response.id);
                        this.$bvModal.hide('manageUsersModal')
                    })
                }).catch((e) => {
                    let errorMsg = e.response.data.message;
                    Swal.fire({
                        toast: true,
                        position: 'top',
                        iconColor: 'white',
                        icon: 'error',
                        title: errorMsg,
                        customClass: {     popup: 'error-toast' },
                        showConfirmButton: false,
                        timer: 2000,
                    });
                    this.is_loading = false;
                    return;
                });
            }
            else{
                this.saveUserToLevel(params)
                .then(()=>{
                    //* when editing all users, the selected_level_id value is null
                    let level_id = this.selected_level_id != null ? this.selected_level_id : 0;
                    this.loadLevelUsers(level_id)
                    .then(()=>{
                        this.is_loading = false;
                        this.$bvModal.hide('manageUsersModal')
                    })
                });
            }
        },
        resetCredentials() {
            Swal.fire({
                title: "Are you sure you want to reset this users credentials?",
                text: "An email will be sent to the user with new login details!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#34c38f",
                cancelButtonColor: "#f46a6a",
                confirmButtonText: "Yes"
            }).then(result => {
                if (result.value) {
                    this.is_loading = true;
                    this.resetUserCredentials({user_id: this.form.id})
                    .then(()=>{
                        this.is_loading = false;
                        Swal.fire({
                            toast: true,
                            position: 'top',
                            icon: 'success',
                            title: 'User Reset',
                            showConfirmButton: false,
                            timer: 2000
                        });
                    });
                }
            });
        },
        assignLevelToUser(level_id){
            var params = {
                user_id: this.form.id,
                level_id: level_id,
            };
            this.addUserToSelectedLevel(params)
            .then(()=>{
                //this.load
                this.$emit('selectNewUser', this.form.id);
            });
        },
        removeUserFromLevel(level_id){
            var params = {
                user_id: this.form.id,
                level_id: level_id,
            };
            this.removeUserFromSelectedLevel(params)
            .then(()=>{
                //this.load
                this.$emit('selectNewUser', this.form.id);
            });
        },
        downloadAllFiles(){
            this.is_loading = true;
            let base = process.env.VUE_APP_API_BASEURL;
            let user_id = this.form.id;
            window.axios({
                url: base+'api/clientadmin/downloadpersonneldoczip/'+user_id,
                method: 'GET',
                responseType: 'blob'
            })
            .then((response)=>{
                const url = window.URL.createObjectURL(response.data);
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'All_documents.zip');
                document.body.appendChild(link);
                link.click();
                this.is_loading = false;
            })
            .catch(()=>{
                this.is_loading = false;
            })
        },
        downloadFile(type){
            let base = process.env.VUE_APP_API_BASEURL;
            let user_id = this.form.id;
            window.axios({
                url: base+'api/clientadmin/downloadpersonneldoc/'+user_id+'/'+type,
                method: 'GET',
                responseType: 'blob'
            })
            .then((response)=>{
                const url = URL.createObjectURL(response.data);
                const link = document.createElement('a');
                link.href = url;
                link.download = type;
                // Programmatically trigger a click event on the link element
                const clickEvent = new MouseEvent('click', {
                    view: window,
                    bubbles: true,
                    cancelable: false
                });
                link.dispatchEvent(clickEvent);

                // Clean up the URL object after the download
                URL.revokeObjectURL(url);
            })
        },
        //Todo - maybe move to a more generic helper js file
        generateRandomId() {
            // return random id;
            return window.webix.uid().toString();
        },
    },
    mounted(){
        if(this.user_data == null){
            this.form = {
                id: -1,
                level_id: '',
                name: '',
                cell_no: '',
                email: '',
                designation: '',
                id_number: '',
                academic_qualifications: '',
                work_qualifications: '',
                years_experience: '',
                id_copy_s3_src: '',
                job_desc_s3_src: '',
                letter_of_acceptance_s3_src: '',
                letter_of_appointment_s3_src: '',
                police_clearance_s3_src: '',
            };
            this.is_new_user = true;
            this.show_form = true;
        }
        else{
            this.form = _.cloneDeep(this.user_data);
            this.$nextTick(()=>{
                this.show_form = true;
            })
        }
    },
}
</script>

<style>
    .usersForm > .row{
        padding-bottom: 0.9rem;
    }

    .accordion > div{
        padding-bottom: 0.8rem;
    }
    .removeLevelIcon{
        cursor: pointer;
        color: black;
        position: absolute;
        right: 10px;
    }
    .removeLevelIcon:hover{
        color: red;
    }
</style>
